<img src="../../../assets/toro.png" alt="Toro Logo" class="logo" />
<img src="../../../assets/icons/sign-in-page.png" alt="Sign In Icon" class="icon" />
<div class="page">
  <div class="container">
    <h1 class="title mb-3">Sign In to Toro Diagnostic Tool</h1>
    <p class="subtitle text-gray-600 mb-4">
      Manage client systems, simplify handoffs, and unlock the insights you need to make smarter decisions.
    </p>

    <!-- Server Error Banner -->
    <div *ngIf="serverError" class="server-error-banner" role="alert">
      <svg viewBox="0 0 24 24" width="20" height="20" fill="#EF4444">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
      </svg>
      <div class="error-content">
        <strong>{{ serverError }}</strong>
      </div>
    </div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
      <!-- Email or Number -->
      <div class="field" [class.invalid]="showError(emailOrMobileNo)">
        <label for="emailOrMobileNo" class="label">Email or Number</label>
        <input id="emailOrMobileNo" type="text" formControlName="emailOrMobileNo"
          placeholder="Enter your email or number" autocomplete="username"
          [attr.aria-invalid]="showError(emailOrMobileNo)" class="input" />
        <div class="error" *ngIf="showError(emailOrMobileNo)">
          <span class="warn-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="#EF4444">
              <path d="M1 21h22L12 2 1 21zm12-3h-2v2h2v-2zm0-8h-2v6h2V10z"></path>
            </svg>
          </span>
          <span>Email or phone number is required.</span>
        </div>
      </div>

      <!-- Password -->
      <div class="field" [class.invalid]="showError(password)">
        <label for="password" class="label">Password</label>

        <div class="password-wrap">
          <input id="password" class="input" [type]="hide ? 'password' : 'text'" formControlName="password"
            placeholder="Enter your password" autocomplete="current-password"
            [attr.aria-invalid]="showError(password)" />

          <button type="button" class="toggle" (click)="togglePassword()"
            [attr.aria-label]="hide ? 'Show password' : 'Hide password'">
            <!-- Eye icon -->
            <svg *ngIf="hide" viewBox="0 0 24 24" width="20" height="20" fill="#6B7280">
              <path d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12c-2.76 0-5-2.24-5-5
                   s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8a3 3 0 100 6 3 3 0 000-6z"></path>
            </svg>
            <!-- Eye-off icon -->
            <svg *ngIf="!hide" viewBox="0 0 24 24" width="20" height="20" fill="#6B7280">
              <path d="M12 5c-3.86 0-7.05 2.19-9.19 4.5C2.42 10.59 2 11.27 2 12c0 .73.42 1.41.81 1.5C4.95 15.81 8.14 18 12 18c3.86 0 7.05-2.19 9.19-4.5.39-.59.81-1.27.81-2
                       0-.73-.42-1.41-.81-1.5C19.05 7.19 15.86 5 12 5z"></path>
              <line x1="3" y1="3" x2="21" y2="21" stroke="#6B7280" stroke-width="2"></line>
            </svg>
          </button>
        </div>

        <div class="error" *ngIf="showError(password)">
          <span class="warn-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="#EF4444">
              <path d="M1 21h22L12 2 1 21zm12-3h-2v2h2v-2zm0-8h-2v6h2V10z"></path>
            </svg>
          </span>
          <span>Password is required.</span>
        </div>

        <button type="button" class="link" (click)="onForgotPassword()">FORGOT PASSWORD</button>
      </div>

      <!-- Submit -->
      <button type="submit" class="primary" [disabled]="loading || form.invalid" [class.loading]="loading">
        <span *ngIf="loading" class="spinner"></span>
        <span>{{ loading ? 'SIGNING IN...' : 'SIGN IN' }}</span>
      </button>
    </form>
  </div>
</div>